import { text, integer, index, uniqueIndex } from 'drizzle-orm/sqlite-core'
import { defineTable } from '@kubdee/sdk/schema'

// ============================================================================
// connectors_types — Catalog ของ integration types ที่รองรับทั่วทั้งระบบ
//
// Global (not per-tenant). Lists available providers (facebook-messenger,
// line-oa, instagram-dm, shopee, gmail, google-calendar, ...) with their
// capabilities and OAuth/webhook config.
// ============================================================================
export const connectorTypes = defineTable(
  'connectors',
  'types',
  {
    id: text('id').primaryKey(),
    slug: text('slug').notNull(),
    name: text('name').notNull(),
    icon: text('icon'),
    iconUrl: text('icon_url'),
    capabilities: text('capabilities').notNull(),
    oauthConfig: text('oauth_config'),
    webhookConfig: text('webhook_config'),
    isActive: integer('is_active').notNull().default(1),
    createdAt: text('created_at').notNull(),
    createdBy: text('created_by'),
    updatedAt: text('updated_at').notNull(),
    updatedBy: text('updated_by'),
  },
  (table) => [
    uniqueIndex('connectors_types_slug_unique').on(table.slug),
    index('connectors_types_is_active_idx').on(table.isActive),
  ],
)

export type ConnectorType = typeof connectorTypes.$inferSelect
export type NewConnectorType = typeof connectorTypes.$inferInsert
